import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslationDomainService } from '@app/translation/domain/translation-domain.service';
import { AuthDomainService } from '@app/auth/domain/auth-domain.service';

@Injectable({ providedIn: 'root' })
export class UserTranslationResolver implements Resolve<string | undefined> {
  constructor(
    private authDomainService: AuthDomainService,
    private translationDomainService: TranslationDomainService,
  ) {}

  resolve(): string | undefined {
    const userLanguage = this.authDomainService.getStorageAuthData()?.language;
    if (userLanguage && userLanguage !== this.translationDomainService.getActiveLanguage()) {
      this.translationDomainService.setActiveLanguage(userLanguage);
    }
    return userLanguage;
  }
}
